import { type ReactElement } from 'react';
import { s } from '@/theme/tokens';
import { Box, Text } from '@/ui/primitives';

export const OperationTableV2CountCell = ({
  label,
  value,
}: {
  label: string;
  value: number | null | undefined;
}): ReactElement => (
  <Box sx={{ display: 'grid', gap: s('none'), minWidth: 0 }}>
    <Text role="body" component="span" sx={{ fontVariantNumeric: 'tabular-nums' }}>
      {String(value ?? 0)}
    </Text>
    <Text role="captionSmall" color="textSecondary" component="span">
      {label}
    </Text>
  </Box>
);

export const OperationTableV2DashCell = (): ReactElement => (
  <Text role="body" component="span" color="textSecondary">
    -
  </Text>
);
